<app-top-menu></app-top-menu>
<div class="bg-forgot">
    <div class="container">
        <div class="row popeye">
            <div class="col-md-5 tax-payee">
                <h6 class="mt-4 mb-4" style="text-align: center">Forgot Your Password?</h6>
                <form [formGroup]="forgotForm" (ngSubmit)="resetPassword()">
                    <div class="form-group app-center mb-4">
                        <label>
                            <small>Email Address</small>
                            <input 
                                class="form-control" 
                                placeholder="example@gmail.com"
                                formControlName="email"
                                type="email"
                                [ngClass]="{ 'is-invalid': forgotForm.controls.email.touched && forgotForm.controls.email.invalid && forgotForm.controls.email.errors?.required || forgotForm.controls.email.errors?.email, 'form-control': true }" 
                            />
                        </label>
                    </div>

                    
                    <div class="app-center mb-4">
                        <button class="btn btn-block btn-warning" type="submit">
                            Send Reset Link
                        </button>
                    </div>

                    <div class="form-group app-center mb-2 mt-1">
                        <label>
                            <a href="#" routerLink="/auth/login">
                                Back to Login
                            </a>
                        </label>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>